<div class="wrapper flex flex-col">
  <div class="heading text-type-2">Activity IDs</div>
  <app-activity-codes-details-form
    [data]="data"
  />
  <app-actions-section
    [disableOptionMenu]="disableOptionMenu"
    [hideDeleteOption]="hideDeleteOption"
    class="actions-section w-[455px]"
  />
</div>
